import React, { useEffect, useCallback, useRef, useState } from "react";
import { Link, withRouter, NavLink } from "react-router-dom";
import Connect from "../../../shared/redux/Connect.hoc";
import {FaRegUserCircle} from "react-icons/fa";
import "./styles.scss";
import user from '../../../shared/media/user.png';

function SideMenuAcount({ state, history }) {
  useEffect(() => {
    console.log("--SideMenuAcount.useEffect--");
  }, []);

  return (
    <nav className="SideMenuAcount-Div">
      <div className="SideMenuAcount-Div-Image">
        {
          state.auth.user.img ? 
          <img  alt="imagen_perfil" src={state.auth.user.img} />
          :
          <FaRegUserCircle
          size="8rem"
          className ="SideMenuAcount-Div-Image-Icon"/>
        }
        <p>{state.auth.user.name + " " + state.auth.user.lastname}</p>
      </div>
      <hr />
      <div className="SideMenuAcount-Div-Menu">
      <NavLink className="SideMenuAcount-Div-Menu-NavLink" activeStyle={{ color: '#2994CD' }} to="/perfil">
        Informacion Personal
      </NavLink>
      <NavLink className="SideMenuAcount-Div-Menu-NavLink" activeStyle={{ color: '#2994CD' }} to="/misservicios">
        Mis Servicios
      </NavLink>
      <NavLink className="SideMenuAcount-Div-Menu-NavLink" activeStyle={{ color: '#2994CD' }} to="/mismensajerias">
        Mis Mensajerias
      </NavLink>
      <NavLink className="SideMenuAcount-Div-Menu-NavLink" activeStyle={{ color: '#2994CD' }} to="/help">Ayuda</NavLink>
      </div>


    </nav>

  );
      }
export default withRouter(Connect(SideMenuAcount));
